export const HEART_MOVE_TO_72 = { x: 49.5, y: 0.5 }

/** Path x,y live in ~[0.5, 71.5]; stretch to full box (same visual weight as 72×72 square). */
const HEART_PATH_EXTENT = 71

/** Cubic segment: control1, control2, end point (SVG C command). */
type HeartCubicSegment = {
  cx1: number
  cy1: number
  cx2: number
  cy2: number
  x: number
  y: number
}

export const HEART_CUBIC_SEGMENTS_72: HeartCubicSegment[] = [
  { cx1: 61.6448, cy1: 0.5, cx2: 71.5, cy2: 10.4531, x: 71.5, y: 22.7461 },
  { cx1: 71.5, cy1: 24.2244, cx2: 71.0364, cy2: 26.1033, x: 70.1807, y: 28.2852 },
  { cx1: 69.3279, cy1: 30.4594, cx2: 68.0995, cy2: 32.8995, x: 66.6035, y: 35.4893 },
  { cx1: 63.6115, cy1: 40.6687, cx2: 59.5672, cy2: 46.4139, x: 55.3701, y: 51.7744 },
  { cx1: 51.1735, cy1: 57.1342, cx2: 46.8332, cy2: 62.0987, x: 43.2539, y: 65.7188 },
  { cx1: 41.4632, cy1: 67.5299, cx2: 39.8708, cy2: 68.9961, x: 38.5879, y: 70.0059 },
  { cx1: 37.9458, cy1: 70.5112, cx2: 37.3912, cy2: 70.8944, x: 36.9355, y: 71.1484 },
  { cx1: 36.4624, cy1: 71.4121, cx2: 36.1593, cy2: 71.5, x: 36, y: 71.5 },
  { cx1: 35.8407, cy1: 71.5, cx2: 35.5376, cy2: 71.4121, x: 35.0645, y: 71.1484 },
  { cx1: 34.6088, cy1: 70.8944, cx2: 34.0542, cy2: 70.5112, x: 33.4121, y: 70.0059 },
  { cx1: 32.1292, cy1: 68.9961, cx2: 30.5368, cy2: 67.5299, x: 28.7461, y: 65.7188 },
  { cx1: 25.1668, cy1: 62.0987, cx2: 20.8265, cy2: 57.1342, x: 16.6299, y: 51.7744 },
  { cx1: 12.4328, cy1: 46.4139, cx2: 8.38852, cy2: 40.6687, x: 5.39648, y: 35.4893 },
  { cx1: 3.90046, cy1: 32.8995, cx2: 2.67212, cy2: 30.4594, x: 1.81934, y: 28.2852 },
  { cx1: 0.963583, cy1: 26.1033, cx2: 0.50002, cy2: 24.2244, x: 0.5, y: 22.7461 },
  { cx1: 0.5, cy1: 10.459, cx2: 10.3553, cy2: 0.5, x: 22.5, y: 0.5 },
  { cx1: 27.4505, cy1: 0.5, cx2: 32.0188, cy2: 2.15381, x: 35.6973, y: 4.94629 },
  { cx1: 35.7982, cy1: 5.02278, cx2: 35.8991, cy2: 5.09927, x: 36, y: 5.17578 },
  { cx1: 36.1009, cy1: 5.09927, cx2: 36.2018, cy2: 5.02278, x: 36.3027, y: 4.94629 },
  { cx1: 39.9812, cy1: 2.15381, cx2: 44.5495, cy2: 0.500001, x: 49.5, y: 0.5 },
]

function normalizePoint(
  p: { x: number; y: number },
  width: number,
  height: number
): { x: number; y: number } {
  return {
    x: ((p.x - 0.5) / HEART_PATH_EXTENT) * width,
    y: ((p.y - 0.5) / HEART_PATH_EXTENT) * height,
  }
}

/**
 * Returns the SVG path string for the heart with cubic curves (M + C + Z),
 * normalized to the given width and height.
 */
export function getHeartPathString(width: number, height: number): string {
  const m = normalizePoint(HEART_MOVE_TO_72, width, height)
  const parts: string[] = [`M ${m.x} ${m.y}`]

  for (const seg of HEART_CUBIC_SEGMENTS_72) {
    const c1 = normalizePoint({ x: seg.cx1, y: seg.cy1 }, width, height)
    const c2 = normalizePoint({ x: seg.cx2, y: seg.cy2 }, width, height)
    const end = normalizePoint({ x: seg.x, y: seg.y }, width, height)

    parts.push(`C ${c1.x} ${c1.y} ${c2.x} ${c2.y} ${end.x} ${end.y}`)
  }

  parts.push('Z')

  return parts.join(' ')
}
